<template>
  <div>

    <div class="popup-bg" v-if="popupBg"></div>

    <div class="container-full popup" v-if="popupNewFolder">
      <div class="container">
        <div class="grid-6 push-3">
          <div class="grid-12 padding-sm box">
            <div class="grid-8 padding-sm">
              <h2>Adicionar pasta</h2>
            </div>
            <div class="grid-4 align-right padding-sm">
              <i class="fas fa-times click" @click="popupBg=false;popupNewFolder=false"></i>
            </div>
            <div class="grid-12 no-padding" v-if="!loading.newFolder">
              <div class="grid-12 padding-sm">
                <input class="form-field" v-model="newFolder.name" placeholder="Nome da pasta">
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full" @click.prevent="createFolder()">Criar</button>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full button-off" @click="popupBg=false;popupNewFolder=false">Cancelar</button>
              </div>
            </div>
            <div class="grid-12 padding-sm" v-if="loading.newFolder">
              <i class="fas fa-spinner fa-spin"></i> Criando pasta...
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-full popup" v-if="popupEditFolder">
      <div class="container">
        <div class="grid-6 push-3">
          <div class="grid-12 padding-sm box">
            <div class="grid-8 padding-sm">
              <h2>Editar pasta</h2>
            </div>
            <div class="grid-4 align-right padding-sm">
              <i class="fas fa-times click" @click="popupBg=false;popupEditFolder=false"></i>
            </div>
            <div class="grid-12 no-padding" v-if="!loading.editFolder">
              <div class="grid-12 padding-sm">
                <input class="form-field" v-model="editableFolder.name" placeholder="Nome da pasta">
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full" @click.prevent="editFolder()">Salvar</button>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full button-off" @click="popupBg=false;popupEditFolder=false">Cancelar</button>
              </div>
            </div>
            <div class="grid-12 padding-sm" v-if="loading.editFolder">
              <i class="fas fa-spinner fa-spin"></i> Salvando...
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-full popup" v-if="popupNewFile">
      <div class="container">
        <div class="grid-6 push-3">
          <div class="grid-12 padding-sm box">
            <div class="grid-8 padding-sm">
              <h2>Adicionar arquivos</h2>
            </div>
            <div class="grid-4 align-right padding-sm">
              <i class="fas fa-times click" @click="popupBg=false;popupNewFile=false"></i>
            </div>
            <div class="grid-12 no-padding" v-if="!loading.newFile">
              <div class="grid-12 padding-sm">
                <input class="form-field" v-model="newFile.name" placeholder="Nome">
              </div>
              <div class="grid-12 padding-sm">
                <select class="form-field" v-model="newFile.display">
                  <option value='download'>Download</option>
                  <option value='youtube'>Youtube</option>
                  <option value='video'>Visualizador de Vídeo</option>
                  <option value='pdf'>Visualizador de PDF</option>
                </select>
              </div>
              <div class="grid-12 padding-sm">
                <span class="click" @click="externalFile=true">
                  <i class="far fa-circle" v-if="!externalFile"></i>
                  <i class="far fa-dot-circle" v-if="externalFile"></i>
                  Arquivo Externo
                </span>
              </div>
              <div class="grid-12 padding-sm" v-if="externalFile">
                <input class="form-field" v-model="newFile.url" placeholder="URL">
              </div>
              <div class="grid-12 padding-sm">
                <span class="click" @click="externalFile=false">
                  <i class="far fa-circle" v-if="externalFile"></i>
                  <i class="far fa-dot-circle" v-if="!externalFile"></i>
                  Upload
                </span>
              </div>
              <div class="grid-12 padding-sm" v-if="!externalFile">
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full" @click.prevent="createFile()">Criar</button>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full button-off" @click="popupBg=false;popupNewFile=false">Cancelar</button>
              </div>
            </div>
            <div class="grid-12 padding-sm" v-if="loading.newFile">
              <div class="progress-bar">
                <div class="progress-bar-inside" :style="'width:'+progress.newFile+'%;'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-full popup" v-if="popupEditFile">
      <div class="container">
        <div class="grid-6 push-3">
          <div class="grid-12 padding-sm box">
            <div class="grid-8 padding-sm">
              <h2>Editar arquivo</h2>
            </div>
            <div class="grid-4 align-right padding-sm">
              <i class="fas fa-times click" @click="popupBg=false;popupEditFile=false"></i>
            </div>
            <div class="grid-12 no-padding" v-if="!loading.editFile">
              <div class="grid-12 padding-sm">
                <input class="form-field" v-model="editableFile.name" placeholder="Nome do arquivo">
              </div>
              <div class="grid-12 padding-sm">
                <select class="form-field" v-model="editableFile.display">
                  <option value='download'>Download</option>
                  <option value='youtube'>Youtube</option>
                  <option value='video'>Visualizador de Vídeo</option>
                  <option value='pdf'>Visualizador de PDF</option>
                </select>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full" @click.prevent="editFile()">Salvar</button>
              </div>
              <div class="grid-4 padding-sm float-right">
                <button class="button button-full button-off" @click="popupBg=false;popupEditFile=false">Cancelar</button>
              </div>
            </div>
            <div class="grid-12 padding-sm" v-if="loading.editFile">
              <i class="fas fa-spinner fa-spin"></i> Salvando...
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-full bg-black" id="play-video" v-if="video">
      <div class="container">
        <div class="grid-10 no-padding-bottom">
          <h1>{{video.name}}</h1>
        </div>
        <div class="grid-2 no-padding-bottom align-right">
          <span class="click" @click="video=null"><i class="fas fa-times fa-2x"></i></span>
        </div>
        <div class="grid-12">
          <div class="embed-container">

            <video width="100%" height="240" controls controlsList="nodownload" class="video-player" v-if="video.display=='video'">
              <source :src="video.url ? video.url : filePath + video.file" type="video/mp4">
              Your browser does not support the video tag.
            </video>

            <iframe width="560" height="315" :src="video.youtubeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen v-if="video.display=='youtube'"></iframe>

          </div>
        </div>
      </div>
    </div>

    <div class="container-full bg-black" id="play-video" v-if="pdf">
      <div class="container">
        <div class="grid-10 no-padding-bottom">
          <h1>{{pdf.name}}</h1>
        </div>
        <div class="grid-2 no-padding-bottom align-right">
          <span class="click" @click="pdf=null"><i class="fas fa-times fa-2x"></i></span>
        </div>
        <div class="grid-12">
          <iframe :src="pdf.url ? pdf.url : filePath + pdf.file" class="display-pdf" v-if="pdf.file"></iframe>
        </div>
      </div>
    </div>

    <div class="container-full">

      <div class="grid-12 no-padding-bottom" v-if="folder">
        <h2><span v-if="folder.restricted"><i class="fas fa-lock" style="color:#f02;"></i></span> {{folder.name}}</h2>
      </div>
      <div class="grid-4 no-padding-bottom" v-if="folder">
        <router-link :to="{ name: 'folder', params: { id: folder.folder }}" v-if="folder.folder"><i class="fas fa-arrow-left"></i> Voltar</router-link>
        <router-link :to="{ name: 'files' }" v-if="!folder.folder"><i class="fas fa-arrow-left"></i> Voltar</router-link>
      </div>
      <div class="grid-8 no-padding-bottom align-right float-right" v-if="!$route.params.search && $store.state.login.admin">
        <span class="click" @click="popupBg=true;popupNewFolder=true"><i class="fas fa-plus-square"></i> Pasta</span>
        &#160;&#160;&#160;
        <span class="click" @click="popupBg=true;popupNewFile=true"><i class="fas fa-plus-square"></i> Arquivo</span>
      </div>
      <div class="grid-12 no-padding-bottom" v-if="$route.params.search">
        <h2>Buscar: {{$route.params.search}}</h2>
      </div>

      <div class="grid-12 no-padding-bottom" v-if="selected.files.length > 0 || selected.folders.length > 0">
        <button class="button" @click="deleteFiles()"><i class="far fa-trash-alt"></i> Excluir</button>
      </div>

      <div class="grid-12">
        <div class="grid-12 no-padding box">
          <div class="grid-12" v-if="!loading.getContent">
          
            <table class="table">
              <thead>
                <tr>
                  <td class="table-icon" v-if="$store.state.login.admin"></td>
                  <td>ARQUIVOS</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>

                <tr v-for="folder in folders" :class="{'selected':selected.folders.includes(folder)}">
                  <td class="table-icon" v-if="$store.state.login.admin">
                    <span @click="selectFolder(folder)">
                      <i class="far fa-square" v-if="!selected.folders.includes(folder)"></i>
                      <i class="far fa-check-square" v-if="selected.folders.includes(folder)"></i>
                    </span>
                  </td>
                  <td>
                  <strong>
                    <i class="fas fa-folder"></i> &#160; <router-link :to="{ name: 'folder', params: { id: folder.id }}">{{folder.name}}</router-link>
                    </strong>
                  </td>
                  <td class="align-right">
                    <span v-if="$store.state.login.admin">
                      <span v-if="folder.restricted" data-balloon="Remover restrição" data-balloon-pos="up" @click="remove_restriction(folder)"><i class="fas fa-lock" style="color:#f02;"></i></span>
                      <span v-if="!folder.restricted" data-balloon="Tornar restrito" data-balloon-pos="up" @click="restrict(folder)"><i class="fas fa-lock-open"></i></span>
                      &#160;&#160;
                    </span>
                    <span class="click" data-balloon="Editar" data-balloon-pos="up" v-if="$store.state.login.admin" @click="popupEditFolder=true;popupBg=true;editableFolder.name=folder.name;editableFolder.id=folder.id;"><i class="fas fa-pencil-alt"></i></span>
                  </td>
                </tr>

                <tr v-for="file in files" :class="{'selected':selected.files.includes(file)}">
                  <td class="table-icon" v-if="$store.state.login.admin">
                    <span @click="selectFile(file)">
                      <i class="far fa-square" v-if="!selected.files.includes(file)"></i>
                      <i class="far fa-check-square" v-if="selected.files.includes(file)"></i>
                    </span>
                  </td>
                  <td>
                    <span v-if="file.display=='video' || file.display=='youtube'" @click="displayVideo(file)">{{file.name}}</span>
                    <span v-if="file.display=='pdf'" @click="displayPdf(file)">{{file.name}}</span>
                    <a :href="file.url ? file.url : filePath + file.file" target="_blank" v-if="file.display=='download'">{{file.name}}</a>
                  </td>
                  <td class="align-right">
                    <span v-if="file.display=='video' || file.display=='youtube'" data-balloon="Assistir" data-balloon-pos="up" @click="displayVideo(file)"><i class="fas fa-play-circle"></i></span>
                    <span v-if="file.display=='pdf'" data-balloon="Visualizar" data-balloon-pos="up" @click="displayPdf(file)"><i class="fas fa-file-alt"></i></span>
                    <a :href="file.url ? file.url : filePath + file.file" target="_blank" v-if="file.display=='download'"><span class="click" data-balloon="Download" data-balloon-pos="up"><i class="fas fa-download"></i></span></a>
                    <span v-if="$store.state.login.admin">
                      &#160;&#160;
                      <span v-if="file.restricted"><i class="fas fa-lock" style="color:#f02;"></i></span>
                      <span v-if="!file.restricted"><i class="fas fa-lock-open"></i></span>
                      &#160;&#160;
                      <span class="click" data-balloon="Editar" data-balloon-pos="up" @click="popupEditFile=true;popupBg=true;editableFile.name=file.name;editableFile.id=file.id;editableFile.display=file.display;"><i class="fas fa-pencil-alt"></i></span>
                    </span>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
          
          <div class="grid-12" v-if="loading.getContent">
            <i class="fas fa-spinner fa-spin"></i> Carregando conteúdo...
          </div>
        </div>
      </div>

      <div class="grid-12 no-padding-top" v-if="selected.files.length > 0 || selected.folders.length > 0">
        <button class="button" @click="deleteFiles()"><i class="far fa-trash-alt"></i> Excluir</button>
      </div>

    </div>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'files',
    data() {
      return {
        folders: [],
        files: [],
        folder: null,
        popupBg: false,
        popupNewFolder: false,
        popupNewFile: false,
        popupEditFolder: false,
        popupEditFile: false,
        externalFile: false,
        video: null,
        filePath: process.env.VUE_APP_API + "/upload/",
        pdf: null,
        progress: {
          newFile: 0,
        },
        loading: {
          newFile: false,
          editFile: false,
          newFolder: false,
          editFolder: false,
          getContent: false
        },
        newFolder: {
          name: ""
        },
        editableFolder: {
          id: null,
          name: ""
        },
        editableFile: {
          id: null,
          name: "",
          display: ""
        },
        newFile: {
          name: "",
          url: "",
          file: "",
          display: "download"
        },
        selected: {
          folders: [],
          files: []
        }
      }
    },
    methods: {
      getContent() {
        this.selected.folders = [];
        this.selected.files = [];
        this.loading.getContent = true;
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        if (this.$route.params.search) {
          data.append('search', this.$route.params.search);
          axios
            .post(process.env.VUE_APP_API + "/search.php", data)
            .then(function (response) {
              self.folders = response.data.folders;
              self.files = response.data.files;
              self.folder = null;
              self.loading.getContent = false;
            })
            .catch(function (error) {
              self.loading.getContent = false;
              self.$store.commit('showMessage', "Ocorreu um erro.");
            });
        } else {
          if (this.$route.params.id) {
            data.append('folder', this.$route.params.id);
          }
          axios
            .post(process.env.VUE_APP_API + "/get_folder_content.php", data)
            .then(function (response) {
              self.folders = response.data.folders;
              self.files = response.data.files;
              self.folder = response.data.folder;
              self.loading.getContent = false;
            })
            .catch(function (error) {
              self.loading.getContent = false;
              self.$store.commit('showMessage', "Ocorreu um erro.");
            });
        }
      },
      createFolder() {
        var self = this;
        var data = new FormData();
        var restricted = (this.newFolder.restricted) ? 1 : 0
        data.append('name', this.newFolder.name);
        data.append('auth_code',  this.$store.state.login.auth_code);
        if (this.$route.params.id) {
          data.append('folder', this.$route.params.id);
        }
        self.loading.newFolder = true;
        axios
          .post(process.env.VUE_APP_API + "/create_folder.php", data)
          .then(function (response) {
            self.newFolder.name = "";
            self.popupBg = false;
            self.popupNewFolder = false;
            self.loading.newFolder = false;
            self.getContent();
          })
          .catch(function (error) {
            self.loading.newFolder = false;
          });
      },
      editFolder() {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        data.append('id', this.editableFolder.id);
        data.append('name', this.editableFolder.name);
        self.loading.editFolder = true;
        axios
          .post(process.env.VUE_APP_API + "/update_folder.php", data)
          .then(function (response) {
            self.editableFolder.id = "";
            self.editableFolder.name = "";
            self.popupBg = false;
            self.popupEditFolder = false;
            self.getContent();
            self.loading.editFolder = false;
          })
          .catch(function (error) {
            self.loading.editFolder = false;
          });
      },
      restrict(folder) {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        data.append('id', folder.id);
        axios
          .post(process.env.VUE_APP_API + "/restrict.php", data)
          .then(function (response) {
            self.getContent();
            self.$store.commit('showMessage', "Pasta restringida.");
          })
          .catch(function (error) {
            self.$store.commit('showMessage', "Ocorreu um erro.");
          });
      },
      remove_restriction(folder) {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        data.append('id', folder.id);
        axios
          .post(process.env.VUE_APP_API + "/remove_restriction.php", data)
          .then(function (response) {
            self.getContent();
            self.$store.commit('showMessage', "Restrição removida.");
          })
          .catch(function (error) {
            self.$store.commit('showMessage', "Ocorreu um erro.");
          });
      },
      async createFile() {
        if (!this.loading.newFile) {
          this.loading.newFile = true;
          var self = this;
          var data = new FormData();
          data.append('auth_code',  this.$store.state.login.auth_code);
          data.append('name', this.newFile.name);
          data.append('display', this.newFile.display);
          if (this.externalFile) {
            data.append('url', this.newFile.url);
          } else {
            data.append('file', this.newFile.file);
          }
          if (this.$route.params.id) {
            data.append('folder', this.$route.params.id);
          }
          await axios
            .post(process.env.VUE_APP_API + "/create_file.php", data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              onUploadProgress (progressEvent) {
                self.progress.newFile = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            })
            .then(function (response) {
              self.loading.newFile = false;
              self.progress.newFile = 0;
              self.newFile.name = "";
              self.newFile.url = "";
              self.newFile.display = "download";
              self.popupBg = false;
              self.popupNewFile = false;
              self.loading.newFile = false;
              self.getContent();
            })
            .catch(function (error) {
              self.loading.newFile = false;
            });
        }
      },
      editFile() {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        data.append('id', this.editableFile.id);
        data.append('name', this.editableFile.name);
        data.append('display', this.editableFile.display);
        self.loading.editFile = true;
        axios
          .post(process.env.VUE_APP_API + "/update_file.php", data)
          .then(function (response) {
            self.editableFile.id = "";
            self.editableFile.name = "";
            self.editableFile.display = "";
            self.popupBg = false;
            self.popupEditFile = false;
            self.getContent();
            self.loading.editFile = false;
          })
          .catch(function (error) {
            self.loading.editFile = false;
          });
      },
      handleFileUpload(){
        this.newFile.file = this.$refs.file.files[0];
      },
      selectFile(file) {
        if (!this.selected.files.includes(file)) {
          this.selected.files.push(file);
        } else {
          this.selected.files.splice(this.selected.files.indexOf(file), 1);
        }
      },
      selectFolder(folder) {
        if (!this.selected.folders.includes(folder)) {
          this.selected.folders.push(folder);
        } else {
          this.selected.folders.splice(this.selected.folders.indexOf(folder), 1);
        }
      },
      deleteFiles() {
        if (confirm("Tem certeza que deseja excluir estes arquivos?")) {
          var self = this;
          var data = new FormData();

          var files = [];
          var folders = [];

          this.selected.files.forEach(function(file) {
            files.push(file.id);
          });

          this.selected.folders.forEach(function(folder) {
            folders.push(folder.id);
          });

          data.append('auth_code',  this.$store.state.login.auth_code);
          data.append('files', files);
          data.append('folders', folders);

          axios
            .post(process.env.VUE_APP_API + "/delete_files.php", data)
            .then(function (response) {
              self.selected.files.forEach(function(file) {
                self.files.splice(self.files.indexOf(file), 1);
              });
              self.selected.files = [];

              self.selected.folders.forEach(function(folder) {
                self.folders.splice(self.folders.indexOf(folder), 1);
              });
              self.selected.folders = [];

              self.$store.commit('showMessage', "Arquivos excluídos");
            })
            .catch(function (error) {
              self.$store.commit('showMessage', "Ocorreu um erro.");
            });
        }
      },
      displayVideo(video) {
        this.video = video;
        if (video.display == "youtube") {
          var url = new URL(video.url);
          var v = url.searchParams.get("v");
          this.video.youtubeUrl = "https://www.youtube.com/embed/" + v;
        }
        window.scrollTo(0,0);
      },
      displayPdf(pdf) {
        this.pdf = pdf;
        window.scrollTo(0,0);
      }
    },
    mounted() {
      this.getContent();
    },
    watch: {
      $route() {
        this.getContent();
      }
    }
  }
</script>